module.exports = __webpack_public_path__ + "img/Ticket Star.3fac03c8.svg";